"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatResultsForFormV3Request = formatResultsForFormV3Request;
function formatResultsForFormV3Request(quizResults, skinResults, skinQuesIdMapping = []) {
    console.log('[profile.processor.formatResultsForFormV3Request.quizResults ] ', quizResults);
    console.log('[profile.processor.formatResultsForFormV3Request.skinResults ] ', skinResults);
    function _formatQuizResults(quizResults) {
        let formattedQuizResults;
        let answerTitleArray, hasAnswerTitle;
        quizResults.forEach(result => {
            answerTitleArray = result.answers.map(answer => answer.title);
        });
        hasAnswerTitle = answerTitleArray.filter(text => text).length > 0;
        if (!hasAnswerTitle) {
            formattedQuizResults = quizResults.map(result => {
                return {
                    questionId: parseInt(result.questionId),
                    answerId: [...new Set(result.answers.map(answer => parseInt(answer.answerId)))],
                };
            });
        }
        else {
            formattedQuizResults = quizResults.map(result => {
                return {
                    questionId: parseInt(result.questionId),
                    answerId: result.answers.map(answer => parseInt(answer.answerId)),
                    answerText: result.answers.map(answer => answer.title).join(','),
                };
            });
        }
        console.log('[profile.processor._formatQuizResults.formattedQuizResults] ', formattedQuizResults);
        return formattedQuizResults;
    }
    function _formatSkinResults(skinResults) {
        const skinQuestionIdMapping = skinQuesIdMapping;
        console.log('[profile.processor._formatSkinResults.skinQuestionIdMapping] ', skinQuestionIdMapping);
        const formattedSkinResults = skinResults
            .filter(result => !!result.attribute)
            .map(result => {
            return {
                questionId: parseInt(skinQuestionIdMapping[result.attribute].questionId),
                answerId: [+skinQuestionIdMapping[result.attribute].answerId],
                answerText: result.score.toString(),
            };
        });
        console.log('[profile.processor._formatSkinResults.formattedSkinResults] ', formattedSkinResults);
        return formattedSkinResults;
    }
    const formattedResults = [];
    if (quizResults === null || quizResults === void 0 ? void 0 : quizResults.length) {
        formattedResults.push(..._formatQuizResults(quizResults));
    }
    if (skinResults === null || skinResults === void 0 ? void 0 : skinResults.length) {
        formattedResults.push(..._formatSkinResults(skinResults));
    }
    console.log('[profile.processor.formatResultsForFormV3Request.formattedResults] ', formattedResults);
    return formattedResults;
}
